<template>
  <div class="payment-notice">
    
      <v-dialog v-model="alertDialog" width="500">
        <div
          class="card card-custom card-custom-center max-500 payment-notice-dialog"
        >
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">Important</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="payment-notice">
              <p>
                Please ensure that you are paying to
                <b>Payment Company.</b> Never make any advance payments to any
                non trusted merchant who provides links through Whatsapp,
                Facebook/Messenger, SMS/Calls for any offers or prizes as it may
                be scam
              </p>
            </div>
            <div class="report-link">
              <p><a href="#">Report if suspicious</a></p>
            </div>
            <div class="continue-pay">
              <v-btn depressed color="primary" width="100%" height="50px" @click.prevent="alertDialog = false">
                Continue
              </v-btn>
            </div>
          </div>
        </div>
      </v-dialog>

  </div>
</template>
<script>
export default {
  name: "Notice",
  data() {
    return {
      alertDialog: false
    };
  }
};
</script>
